export default {
  0: "企業の生産性を向上させるために、さまざまな産業やアプリケーション分野の専門的なソリューションを提供しています。",
  1: "市民が1つのアカウントですべてのシステムにアクセスし、政府のサービスに安全にログインできるようにします。",
  2: "読者が読書に集中できるように、配信、著者、編集者、すべてが指先でできるようになります。",
  3: "権限を与えられた金融クラウド、直観的で視覚的な分析プラットフォームは、国の規制基準に準拠しています。",
  4: "プレイヤーを早く来させて、ハッカーをポイントから遠ざけましょう。複数の ID ソースからの迅速なログインにより、ユーザーの機密情報へのアクセスを確実にします。",
  5: "1つの認証多地点相互接続 1つのソフトウェアグローバル監視",
  6: "WiFi、キャンパスカード、1つのネットワークで学生とスタッフを保護する",
  行业解决方案: "産業別ソリューション",
  免费使用: "無料アクセス",
  查看文档: "ドキュメントを見る",
  查看详情: "もっと詳しく",
  政府: "政府",
  出版: "出版",
  金融: "金融",
  游戏: "ゲーム",
  软件业: "ソフトウェア",
  教育: "教育",
};
